module.exports = __webpack_public_path__ + "img/iconXiTongBuMenLieBiao.24ea6bf3.svg";